import { render, staticRenderFns } from "./troop-item.vue?vue&type=template&id=3938d2e0&scoped=true&"
import script from "./troop-item.vue?vue&type=script&lang=js&"
export * from "./troop-item.vue?vue&type=script&lang=js&"
import style0 from "./troop-item.vue?vue&type=style&index=0&id=3938d2e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938d2e0",
  null
  
)

export default component.exports